<template>
<div class="cont-nav">
  <!--<div id="nav" v-if="token">
    <router-link to="/">{{ $t('home') }}</router-link> |
    <router-link to="/about">{{ $t('about') }}</router-link> |
    <router-link to="/login">{{ $t('login') }}</router-link>
  </div>-->
  <div class="lang-selector p-2">
    <button @click="changeLanguage('it')" class="btn btn-sm btn-outline-dark mx-1" :class="{ active: $i18n.locale === 'it' }">IT</button>
    <button @click="changeLanguage('en')" class="btn btn-sm btn-outline-dark mx-1" :class="{ active: $i18n.locale === 'en' }">EN</button>
    <button @click="changeLanguage('es')" class="btn btn-sm btn-outline-dark mx-1" :class="{ active: $i18n.locale === 'es' }">ES</button>
  </div>
</div>
  <!--<div id="nav" v-if="token">
    <router-link to="/getsionale" >{{ $t('gestionale') }}</router-link> 
  </div>-->
  <router-view/>
  <ModalsContainer />
</template>

<script>
import moment from 'moment'
import { io } from "socket.io-client"
import { store } from './store/store.js'
import { ModalsContainer } from 'vue-final-modal'
import newOrderSound from '@/assets/newOrder.mp3'

let ipcRenderer = null;
try {
  // Guard for web environment
  if (window.require) {
    ipcRenderer = window.require('electron').ipcRenderer;
  }
} catch (e) {
  console.log('Electron ipcRenderer not available');
}

export default {
  name: 'App',
  components: {
    ModalsContainer
  },
  data: function() {

    return {
      token:false,
      socket:io("https://mymenuserver.onrender.com/", { autoConnect: true }),
      prodotti:[],
      store,
      asportoIntervalId: null,
      asportoProcessing: false
    }
  },
  methods :{
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
    },
    displayProduct() {
            this.axios.post(this.store.path+'displayProduct',{headers:{
            authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });
            })
        },
    printPaper(rv) {
      console.log('printPaper! start', rv)
      if (!ipcRenderer) {
        console.log('Printing skipped: ipcRenderer not available (web app)');
        return;
      }
      this.axios.post(this.store.path + 'displayPrinter', {
        headers: {
          authorization: `Bearer  ${JSON.parse(localStorage.token)}`
        }
      })
      .then((response) => {
        if (response.data.messaggio && rv.length) {
          const printers = response.data.messaggio;
          console.log('Available printers:', printers);

          printers.forEach(printer => {
            // Check if this printer should print anything from this order
            let shouldPrint = false;

            rv.forEach(tableOrder => {
              if (tableOrder.ord) {
                const hasMatchingItem = tableOrder.ord.some(item => {
                  if (!item.portata) return false;
                  const itemPortata = item.portata.trim().toLowerCase();
                  
                  if (Array.isArray(printer.postazioni)) {
                    return printer.postazioni.some(p => p.trim().toLowerCase() === itemPortata);
                  } else if (typeof printer.postazioni === 'string') {
                    return printer.postazioni.toLowerCase().split(',').map(s => s.trim()).includes(itemPortata);
                  }
                  return false;
                });

                if (hasMatchingItem) {
                  shouldPrint = true;
                }
              }
            });

            if (shouldPrint) {
              console.log(`Sending FULL order to printer: ${printer.nome} (${printer.ip}:${printer.porta})`);
              // Send the FULL rv instead of filtered data
              ipcRenderer.send('print', rv, {
                ip: printer.ip,
                porta: printer.porta
              });
            } else {
              console.log(`Printer ${printer.nome} has no matching items in this order. Skipping.`);
            }
          });
        } else if (!response.data.messaggio) {
          console.log('Non ci sono stampanti configurate');
        }
        console.log('printPaper! end')
      })
    },
    getDataOrdine (tav,sal) {
      console.log(tav,sal)
    this.moment = moment;
    var end = moment(this.date).endOf('day').unix();
    var start = moment(this.date).startOf('day').unix();
    var data = moment(this.date).format('DD');
    var rv= [];
    var totale = 0;
    
    this.axios.post(this.store.path+'displayOrdine',{codtavolo:tav,sala:sal,end:end,start:start,singolo:true,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
        if(response.data){
          response.data.messaggio.forEach(element => {
              var lastPortata = '';
              element.ordine.forEach(ord => {
                  lastPortata = ord.portata;
                  let itemCostoAggiunta = 0;
                  if (ord.aggiunta && ord.aggiunta.length) {
                      ord.aggiunta.forEach(aggiunta => {
                          let pPrice = 0;
                          if (typeof aggiunta === 'object' && (aggiunta.prezzo !== undefined || aggiunta.prezzoAggiunta !== undefined)) {
                              pPrice = Number(aggiunta.prezzo || aggiunta.prezzoAggiunta) || 0;
                          } else {
                              const desc = typeof aggiunta === 'object' ? (aggiunta.descrizione || aggiunta.nome || '') : String(aggiunta);
                              const code = typeof aggiunta === 'object' ? (aggiunta.prodottoId || aggiunta.code || '') : '';
                              const prod = (this.prodotti || []).find(o => (code && o.code === code) || o.descrizio === desc || o.nome === desc);
                              if (prod && prod.prezzoAggiunta) {
                                  pPrice = Number(prod.prezzoAggiunta) || 0;
                              }
                          }
                          itemCostoAggiunta += pPrice;
                      });
                  }
                  ord.costoAggiunta = itemCostoAggiunta;
                  totale = totale + (ord.costoAggiunta + ord.prezzo) * (ord.quantita || 1);
              })
              rv.push({
                idT: element.idTavolo,
                idO: element.idOrdine,
                t: element.tavolo, 
                ord: element.ordine,
                tm: data,
                portata: lastPortata, 
                sala: sal
              })
          });
  
                this.printPaper([...rv])

        }else{console.log('Nessun Ordine Presente Per Questo Tavolo')}
            })
    },
    async checkNewAsportoOrders() {
      if (this.asportoProcessing) return;
      if (!localStorage.token) return;

      try {
        this.asportoProcessing = true;
        const today = new Date().toISOString().split('T')[0];
        const response = await this.axios.post(this.store.path + 'getOrdiniAsporto', {
          headers: {
            authorization: `Bearer ${JSON.parse(localStorage.token)}`
          }
        });

        if (response.data && response.data.messaggio) {
          const newOrders = response.data.messaggio.filter(o => 
            !o.isPrinted && (
              (o.pagato && o.dataRitiro === today) || 
              o.isStaff
            )
          );

          if (newOrders.length > 0) {
            console.log(`🔔 Trovati ${newOrders.length} nuovi ordini da asporto! Riproduzione alert sonoro...`);
            
            try {
              const audio = new Audio(newOrderSound);
              audio.play().catch(err => console.warn('Autoplay audio bloccato dal browser:', err));
            } catch (soundErr) {
              console.error('Errore riproduzione suono ordine asporto:', soundErr);
            }

            if (ipcRenderer) {
              try {
                const printerRes = await this.axios.post(this.store.path + 'displaySpecificPrinter', {
                  nome: 'asporto'
                }, {
                  headers: {
                    authorization: `Bearer ${JSON.parse(localStorage.token)}`
                  }
                });

                const printers = printerRes.data.messaggio;
                if (printers && printers.length > 0) {
                  const printer = printers[0];
                  for (const ordine of newOrders) {
                    const sanitizedOrder = JSON.parse(JSON.stringify({
                      ord: ordine.ordinazione.map(item => ({
                        ...item,
                        piatto: item.piatto,
                        aggiunta: item.aggiunta || [],
                        senza: item.senza || [],
                        prezzo: item.prezzo,
                        countGroup: item.quantita
                      })),
                      nome: ordine.nome,
                      email: ordine.email,
                      telefono: ordine.telefono,
                      dataRitiro: ordine.dataRitiro,
                      oraRitiro: ordine.oraRitiro,
                      totale: ordine.totale / 100
                    }));

                    ipcRenderer.send('print', sanitizedOrder, {
                      ip: printer.ip,
                      porta: printer.porta
                    }, 'asporto');

                    await this.axios.post(this.store.path + 'segnaAsportoStampato', {
                      id: ordine._id
                    }, {
                      headers: {
                        authorization: `Bearer ${JSON.parse(localStorage.token)}`
                      }
                    });

                    ordine.isPrinted = true;
                  }
                }
              } catch (printErr) {
                console.error('Errore durante la stampa automatica asporto:', printErr);
              }
            }
          }
        }
      } catch (err) {
        console.error('Errore controllo ordini asporto:', err);
      } finally {
        this.asportoProcessing = false;
      }
    }
  },
  beforeMount() {
        this.socket.on('ricevutoOrdine',(messaggio) => {
            console.log(messaggio)
            // Gestione robusta dei diversi formati di messaggio
            let tavoloId = messaggio.tavolo.toString().includes("t") ? messaggio.tavolo.split("t")[1].toString() : messaggio.tavolo.toString();
            let salaNome = messaggio.sala && messaggio.sala.nome ? messaggio.sala.nome : messaggio.sala;
            
            this.getDataOrdine(tavoloId, salaNome)

            // Logica per far diventare verde il tavolo (classe 'ordinato')
            let element = document.getElementById(tavoloId);
            if (element) {
                element.classList.add('ordinato');
            }
        });

        this.socket.on('ricevutoOrdineAsporto', () => {
            console.log('📡 Ricevuto socket ricevutoOrdineAsporto in App.vue');
            this.checkNewAsportoOrders();
        });

        this.checkNewAsportoOrders();
        this.asportoIntervalId = setInterval(this.checkNewAsportoOrders, 15000);
    },
    updated() {
        this.token = localStorage.token;
    },
    created() {
      const savedLang = localStorage.getItem('lang');
      if (savedLang) {
        this.$i18n.locale = savedLang;
      }
    },
    beforeUnmount() {
        if (this.asportoIntervalId) {
            clearInterval(this.asportoIntervalId);
        }
    }
}
</script>


<style>
@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@100&family=Fredericka+the+Great&family=Kelly+Slab&display=swap');
#app {
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 1.1rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #e0e0e0;
  min-height: 100vh;
  width: 100%;
  margin: 0;
  padding: 0;
}

#nav {
  padding: 15px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

body {
  min-height: 100vh;
  margin: 0;
  padding: 0;
  background-color: #e0e0e0;
}
</style>
